<input type="text"
       maxlength="5"
       aria-label="Klokkeslett"
       placeholder="{{placeholder}}"
       class="e2e-klokkeslett"
       (focus)="vedFokusMottatt()"
       (blur)="vedFokusMistet()"
       [formControl]="klokkeslettTekstfelt"
       [matAutocomplete]="autoCompleteKomponent"
       data-testid="klokkeslett-felt"
       #tekstfelt> <!-- inputfeltet injiseres i kontroller via #tekstfelt -->
<span class="tidssone" data-testid="tidssone" [matTooltip]="tidssone">{{ tidssone }}</span>
<mat-autocomplete
        class="klokkeslett-velger--valg"
        panelWidth="100px"
        hideSingleSelectionIndicator="true"
        autoSelectActiveOption="true"
        #autoCompleteKomponent="matAutocomplete"
        (opened)="vedNedtrekksmenyAapnet()">
  @for (klokkeslett of predefinerteKlokkeslett; track klokkeslett) {
    <mat-option [value]="plainTimeTilStreng(klokkeslett)">{{plainTimeTilStreng(klokkeslett)}}</mat-option>
    <!-- dersom vi ønsker å vise klokkeslett på localized format {{ klokkeslett | plaintime }} kan benyttes,
    men det kan skape forventning om at man kan benytte dette formatet også i inputfeltet - noe som krever mer endringer -->
  }
</mat-autocomplete>
